import React, { useState, useEffect } from "react";
import commonStyle from "../common.module.css";
import Topbar from "../../Components/TopBar/TopBar";
import {
  booleanObject,
  datesField,
  TASK_COLUMNS,
  TASK_COLUMNS_REAL,
} from "../../Values/tables";
import { connect, useDispatch } from "react-redux";
import { fetchTasks } from "../../Services/contacts";
import {
  getFilterObject,
  searchTaskItem,
  filterTaskStatus,
} from "../../Values/utils";
import styles from '../Analytics/Analytics.module.css';
import Loading from "../../Components/Loading/Loading";
import CustomTable from "../../Components/CustomTable/CustomTable";
import {
  getDateString,
  searchContacts,
  getDateStringUpdated
} from "../../Values/utils";

import axios from "axios";

import moment from "moment";

import { taskFilterValues, url } from "../../Values/constants";
import {
  setFilterObject,
  setRefreshTasks,
  showSnackbarAction,
  clearAllFilters,
  setCurrentRoute
} from "../../Redux/actions";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import {themeColors} from "../../Components/theme";
import PopUpBox from "../AuditLogs/PopUpBox";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics } from "../../Services/users";
import { useLocation } from 'react-router-dom';
import HtmlBanner from "../../bannerManagement/baneerComp";


let isFinished = false;
const Task = ({
  history,
  user,
  branchUsers,
  filterObject,
  searchString,
  filterSort,
  refreshTasks,
  theme,
  authToken,
  organizationData,
  organizationUsers
}: any) => {
  const [tasksList, setTasksList] = useState<
    any[] | undefined
  >(undefined);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [temporaryData, setTemporaryData] = useState<any[]>(
    []
  );
  const [searchQuery, setsearchQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [columnModal, setColumnModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>(
    []
  );
  const [selectedRowsData, setSelectedRowsData] = useState<
    any[]
  >([]);
  const [showImportModal, setShowImportModal] =
    useState(false);
  const [uidMap, setUidMap] = useState<any>();

  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allTasks, setAllTasks] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>({});
  const [filterCount, setFilterCount] = useState<any>({})
  const [searchedItem, setsearchedItem] = useState("");

  const dispatcher = useDispatch();
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [userEmail, setUserEmail] = useState<any>({});  
  const [showColumns, setShowColumns] = useState<any>(null); 
  const [isGACalled, setIsGACalled] = useState<any>(false);
    const [cRoute,setCRoute]=useState("")

      const location = useLocation();

  useEffect(() => {
    dispatcher(setCurrentRoute(location.pathname))
    setCRoute(location.pathname)
  }, [location]);

  // useEffect(()=>{
  //   dispatcher(clearAllFilters({}));
  // },[])

  useEffect(() => {
    if (organizationUsers) {
      // console.log("CSASADC",organizationUsers)
      let emailInfo: { [key: string]: string } = {};
      organizationUsers.forEach((user1: any) => {
        emailInfo[user1.user_email]=user1;
      });
      setUserEmail(emailInfo)
    }
  }, [organizationUsers]);
  useEffect(() => {
  }, [searchString]);

  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      // const filters: { [key: string]: any[] } = {};
      const filters: { [key: string]: any[] } = {};
      let feild;
      filters["transfer_status"] = [false];
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status" || item === "unique_meeting" || item === "unique_site_visit") {
            if (filterObject[item].length === 2) {
              filters[item] = [true, false];
            } else {
              filters[item] =
                filterObject[item][0] === "True" ? [true] : [false];
            }
          } else {
            if (item === "contact_no") {
            } else filters[item] = filterObject[item];
          }
        }
      });
      if (searchString === "") {
        feild = "contact_no";
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = "contact_no";
        } else {
          feild = "customer_name";
        }
      }
      let records = localPageSize
        ? localPageSize
        : pageSize;
      const apiData = {
        uid: user.uid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: "-1" }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        filter: filters,
      };
      setFilterCount(filters)
      
      try {
        const res = await axiosHandler.post(
          url + "/tasks/search",
          apiData
        );
        let data: any[] = res.data;

        if (data.length < records && paginate) {
          isFinished = true;
          setLastPage(page);
        }

        data.forEach((task) => {
          // if (userEmail && userEmail[task.contact_owner_email]) {
            let info=userEmail[task.contact_owner_email];
            if(info){
              task.employee_id=info.employee_id?info.employee_id:"";
              if(info.user_first_name || info.user_last_name){
                task.employee_name=info.user_first_name+" "+info.user_last_name;
              }
            // }
          }
          if (task.status === "Pending" && task.due_date < new Date().toISOString()) {
            task.status = "Overdue";
          }
          task.contactId = task.leadId;

          task.reporting_to =
            userMap[task.contact_owner_email];
          delete task["Id"];
          Object.keys(task).forEach((key) => {
            if (
              datesField.includes(key) &&
              task[key] !== ""
            ) {
              if (task[key] !== null) {
                task[key] = moment(task[key]);
              } else {
                task[key] = "";
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
          setLoad(false);
        } else {
          setFilterData(data);
          setLoad(false);
        }
      } catch (error){
        setFilterData([]);
        setLoad(false);
        dispatcher(
          showSnackbarAction("Please Try Again!!", "error")
        );
      }
    }
  };

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      // setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [
    user,
    filterObject,
    filterSort,
    searchString,
    allTasks,
    authToken,
    userEmail
  ]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken,userEmail]);

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      // setFilterData([]);
      return;
    }
    if(authToken){
      callCountApi();
    }
  }, [refreshTasks, user.uid, filterCount,authToken]);

  const callCountApi = async () => {
    const res = await axiosHandler.post(url + "/tasks/taskCount", {
      uid: user.uid,
      leadFilter: filterCount
    });
    // console.log(res,"GRGEGERGVVRG")
    setTotalCounts(res.data.total);
  };

  useEffect(() => {
    if (refreshTasks === true) {
      if(authToken){
        callApi();
      getTasksFilter();
      dispatcher(setRefreshTasks(false));
      }
    }
  }, [refreshTasks,authToken,userEmail]);

  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('taskShowFilterValues');
  //   setShowColumns(storedValue);
  //   getTasksFilter();
  // },[localStorage.getItem('taskShowFilterValues'),showColumns])

  const getTasksFilter = async () => {
      const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
        organization_id: user.organization_id,
        uid: user.uid,
        });
    const res = await axiosHandler.post(
      url + "/tasks/filterValues",
      {
        // uid: user.uid,
        showColumns:showColumns === null?taskFilterValues:JSON.parse(showColumns)
      }
    );
    if (res.data[0]) {
      dispatcher(
        setFilterObject({
          ...res.data[0],
          'employee_name':userdetail.data.data.Employee_Name,
          'employee_id':userdetail.data.data.Employee_id,
          ...booleanObject,
          status: ["Pending", "Overdue", "Completed"],
        })
      );
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('taskShowFilterValues');
    setShowColumns(storedValue);
    if (user === undefined || user.uid === undefined) {
      return;
    }
    if(authToken){
      getTasksFilter();
    }
  }, [user,authToken,localStorage.getItem('taskShowFilterValues') ,showColumns]);

  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length === 0) {
    } else {
      selectedRowsData.forEach((item) => {
      // console.log("itemData",item.due_date,item.created_at, item.completed_at)

        data.push({
          // "Lead Id": item.leadId,
          "Customer Name": item.customer_name,
          "Task Type": item.type,
          'Lead Assignee Email': item.contact_owner_email,
          "Lead Stage": item.stage,
          Project: item.project,
          Location: item.location,
          Budget: item.budget,
          "Contact Number": item.contact_no,
          // "Inventory Type": item.inventory_type,
          // 'Lead Source': item.source,
          "Transfer Status": item.transfer_status,
          "Due On": getDateStringUpdated(item.due_date),
          "Completed On": getDateStringUpdated(
            item.completed_at
          ),
          "Call Back Reason": item.call_back_reason,
          Status: item.status,
          "Created By": item.created_by,
          "Created On": getDateStringUpdated(
            item.created_at
          ),
          "Employee ID":item.employee_id,
          "Employee Name": item.employee_name,
          "Lead State": item.state,
        });
      });
    }

    return data;
  };

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Task_Screen',user)
      }
    }
  },[user])

      const [isHardRefresh, setIsHardRefresh] = useState(false);

useEffect(() => {
  const navEntries:any = performance.getEntriesByType('navigation');
  if (navEntries.length > 0 && navEntries[0].type === 'reload') {
    setIsHardRefresh(true);
  }
}, []);

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: "0px",...containerStyles}}>
      {load === true && <Loading/>}

          {cRoute&& isHardRefresh&&( <div className={styles.PbContainer}>
        <HtmlBanner   user={user} route={cRoute} bannerType={"pageBanner"}/>
      </div>)}

        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <ApiTopBar
            history={history}
            title={"Add Task"}
            path={"/addTasks"}
            onClick={() => {
              setShowImportModal(true);
            }}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={false}
            onExport={exportFile}
            searchedString={searchString}
            selectedRows={selectedRows}
            setAuditLog={setAuditLog} 
            isOtpVerified={isOtpVerified}
            panel = "tasks"
          />
        </div>
        <div className={commonStyle.parent} style={{minHeight:"450px",...containerStyles}}>
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
          <ApiCustomTable
            tableColumns={TASK_COLUMNS_REAL}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Task"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) =>
              setSelectedRowsData(data)
            }
            setPage={(val) => setPage(val)}
            setPageSize={(val) => setPageSize(val)}
            callApi={callApi}
            pageSize={pageSize}
            page={page}
            isFinished={isFinished}
            totalCount={totalCounts}
            lastPage={lastPage}
          />:
          <ApiCustomTable
            tableColumns={TASK_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Task"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) =>
              setSelectedRowsData(data)
            }
            setPage={(val) => setPage(val)}
            setPageSize={(val) => setPageSize(val)}
            callApi={callApi}
            pageSize={pageSize}
            page={page}
            isFinished={isFinished}
            totalCount={totalCounts}
            lastPage={lastPage}
          />
          }
           {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "tasks"
              />)}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    branchUsers: state.branchUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.taskFilter,
    filterSort: state.taskfilterSort,
    searchString: state.searchItem.tasksSearchString,
    refreshTasks: state.refresh.refreshTasks,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    organizationUsers: state.organizationUsers.data,
  };
};

export default connect(mapStateToProps)(Task);
